/**
 * rw-yancha-cart-thumb-hover
 *
 * カート内のデザイン画像（メイン商品サムネイル）が複数ある場合、
 * カーソルを乗せた「左右の位置」に応じて表示画像を切り替える。
 * （自動巡回ではなく、画像幅を枚数で等分したゾーンで切り替え）
 *
 * 対象マークアップ（snippets/rw-cart-item-row.liquid）:
 *   <span data-rw-design-thumbs class="rw-cart-thumb-switch">
 *     <img class="rw-cart-thumb-switch__img is-active" ...>
 *     <img class="rw-cart-thumb-switch__img" ...>
 *   </span>
 *
 * カート再描画（morph）後も動くよう document への委譲で監視する。
 */
(function () {
  if (window.__rwYanchaCartThumbHoverInit) return;
  window.__rwYanchaCartThumbHoverInit = true;

  function getImages(container) {
    return container.querySelectorAll('.rw-cart-thumb-switch__img');
  }

  function setActive(container, index) {
    var images = getImages(container);
    var total = images.length;
    if (!total) return;
    var active = ((index % total) + total) % total;
    // 変化が無ければ何もしない（mousemove の連続発火対策）
    if (container.__rwThumbActive === active) return;
    for (var i = 0; i < total; i++) {
      images[i].classList.toggle('is-active', i === active);
    }
    container.__rwThumbActive = active;
  }

  /** カーソルの横位置から表示すべき画像インデックスを求める。 */
  function indexFromEvent(container, event) {
    var total = getImages(container).length;
    if (total < 2) return 0;
    var rect = container.getBoundingClientRect();
    if (rect.width === 0) return 0;
    var ratio = (event.clientX - rect.left) / rect.width;
    if (ratio < 0) ratio = 0;
    if (ratio > 0.9999) ratio = 0.9999;
    return Math.floor(ratio * total);
  }

  document.addEventListener('mousemove', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var container = target.closest('[data-rw-design-thumbs]');
    if (!container) return;
    setActive(container, indexFromEvent(container, event));
  });

  // コンテナから出たら先頭画像に戻す
  document.addEventListener('mouseout', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var container = target.closest('[data-rw-design-thumbs]');
    if (!container) return;
    if (event.relatedTarget && container.contains(event.relatedTarget)) return;
    setActive(container, 0);
  });
})();
